import { composeIO } from 'react-compose-io'
import { modalFiltroParceiroIO } from './ModalFiltroParceiro.IO'
import ModalFiltroParceiroView from './ModalFiltroParceiro.View'

export const ModalFiltroParceiro = composeIO(ModalFiltroParceiroView, modalFiltroParceiroIO)
